export default "__VITE_ASSET__C16eUmdU__"